/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import store from "./store/index"
import VueLoading from 'vuejs-loading-plugin'
import VueAWN from "vue-awesome-notifications"
import IframeMixin from './mixins/iframe-mixins'
import PortalVue from 'portal-vue'


require('./bootstrap');

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize
 * the JavaScript scaffolding to fit your unique needs.
 */

window.Vue = require('vue');
Vue.use(require('vue-moment'));

Vue.use(PortalVue)


window.axios.defaults.headers.common = {
    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
    'X-Requested-With': 'XMLHttpRequest'
};

Vue.component('site-inspection-frequency-component', require('./components/modules/sites/InspectionFrequencyComponent').default);
Vue.component('site-card-component', require('./components/modules/sites/SiteCardComponent').default);
Vue.component('site-header-summary-component', require('./components/modules/sites/SiteHeaderSummaryComponent').default);
Vue.component('site-header-component', require('./components/modules/sites/SiteHeaderComponent').default);
Vue.component('site-documents-component', require('./components/modules/sites/SiteDocumentsComponent').default);
// Vue.component('site-client-contacts', require('./components/modules/sites/ClientContactsSite').default);
Vue.component('generic-sites', require('./components/modules/sites/GenericSites').default);
Vue.component('generic-billing-accounts', require('./components/modules/billing_accounts/GenericBillingAccount').default);

Vue.component('dashboard-card-component', require('./components/generics/DashboardCardComponent.vue').default);
Vue.component('required-field', require('./components/RequiredField.vue').default);
Vue.component('global-document', require('./components/generics/GlobalDocumentComponent').default);
Vue.component('inspection-document', require('./components/generics/InspectionDocumentComponent.vue').default);
Vue.component('select-component', require('./components/SelectComponent').default);
Vue.component('select-data-component', require('./components/generics/SelectDataComponent.vue').default);
Vue.component('select-simple-component', require('./components/SelectSimpleComponent').default);
Vue.component('ckeditor-component', require('./components/CKeditorComponent').default);
Vue.component('generic-select', require('./components/generics/generic-select/g-select').default);
Vue.component('select-boolean-component', require('./components/SelectBooleanComponent').default);
Vue.component('modal-default', require('./components/generics/ModalDefault.vue').default);
Vue.component('email-vetorial', require('./components/generics/EmailVetorial.vue').default);
Vue.component('cash-receipt-form', require('./components/modules/billings/CashReceiptForm.vue').default);

//schedules
Vue.component('schedule-default-period', require('./components/modules/schedules/ScheduleDefaultPeriod.vue').default);
Vue.component('schedule-calendar-component', require('./components/modules/schedules/ScheduleCalendar.vue').default);
Vue.component('schedule-calendar-mobile-component', require('./components/modules/schedules/ScheduleMobileCalendar.vue').default);
Vue.component('schedule-supervisor-option-component', require('./components/modules/schedules/ScheduleSupervisorOption.vue').default);
Vue.component('schedule-coi-required-component', require('./components/modules/schedules/ScheduleCoiRequired.vue').default);
Vue.component('po-number', require('./components/modules/schedules/PONumber.vue').default);
Vue.component('schedule-material-component', require('./components/modules/schedules/ScheduleMaterialsComponent.vue').default);
Vue.component('schedule-confirmed-by-client', require('./components/modules/schedules/ScheduleConfirmedByClient.vue').default);
Vue.component('schedule-dispatch', require('./components/modules/schedules/ScheduleDispatch.vue').default);
Vue.component('schedule-matrix-hours', require('./components/modules/schedules/ScheduleMatrixHours.vue').default);
Vue.component('schedule-dispatch-contact', require('./components/modules/schedules/ScheduleDispatchContact.vue').default);
Vue.component('service-ticket-material-component', require('./components/modules/work_orders/ServiceTicketMaterialsComponent.vue').default);
Vue.component('technician-times-material-component', require('./components/modules/schedules/TechnicianTimesComponent.vue').default);
Vue.component('workticket-technicians-component', require('./components/modules/schedules/WorkTicketTechniciansComponent.vue').default);


Vue.component('timesheet-time', require('./components/modules/work_orders/TimesheetTimeComponent.vue').default);
Vue.component('schedule-check-online', require('./components/modules/schedules/ScheduleCheckOnline.vue').default);

Vue.component('current-year', require('./components/CurrentYear.vue').default);
Vue.component('contract-date', require('./components/modules/contracts/ContractDate.vue').default);


Vue.component('generic-insurance-certificates', require('./components/modules/insurance_certificates/GenericInsuranceDocumentType.vue').default);
Vue.component('generic-contact-types', require('./components/modules/contacts/GenericContactType.vue').default);
Vue.component('generic-client-contacts', require('./components/modules/contacts/GenericClientContact.vue').default);
Vue.component('site-client-contact-list', require('./components/modules/sites/SiteClientContactList.vue').default);

Vue.component('billing-module', require('./components/modules/billings/Billings.vue').default);


Vue.config.productionTip = false

Vue.component('shortcut-links-items', require('./components/modules/shortcut_links/ShortcutLinkItemComponent').default);

Vue.component('alteration-history', require('./components/history/AlterationHistory.vue').default);
Vue.component('alteration-modal', require('./components/history/Modal.vue').default);
Vue.component('history-full', require('./components/history/HistoryFull.vue').default);


Vue.use(VueLoading, {
    dark: true, // default false
    text: 'Loading...', // default 'Loading'
    loading: false, // default false
    //customLoader: myVueComponent, // replaces the spinner and text with your own
    //background: 'rgb(47, 64, 80)', // set custom background
    classes: ['loading-screen-inspinia', 'animated', 'fadeIn'] // array, object or string
});

Vue.filter('dateUs', function (value) {

    if (value === null) return '';
    if (value === undefined) return '';
    if (value.toString().substring(0, 1) === '-') return '';

    let dateObj = new Date(value)
    return dateObj.toLocaleString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        timeZone: 'UTC'
    }).replace(/\//g, '/')
})

Vue.filter('dateTimeUs', function (value) {
    if (value === null || value === undefined || value.toString().substring(0, 1) === '-') {
        return '';
    }
    const dateObj = new Date(value);
    const options = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
    };
    return dateObj.toLocaleString('en-US', options).replace(/\//g, '/');
});

Vue.filter('dayOfWeek', function(dateString) {
    const daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const date = new Date(dateString);
    return daysOfWeek[date.getUTCDay()];
});

Vue.filter('dayMonthAbbrev', function(dateString) {
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const date = new Date(dateString);
    const day = date.getUTCDate();
    const monthAbbrev = months[date.getUTCMonth()];
    return `${monthAbbrev} ${day}`;
});


Vue.filter('am_pm', function (time) {
    if (!time) return '';
    let [hours, minutes] = time.split(':').map(Number);
    const period = hours < 12 ? 'AM' : 'PM';
    hours = hours % 12 || 12;

    hours = hours < 10 ? '0' + hours : hours;

    return `${hours}:${minutes < 10 ? '0' + minutes : minutes} ${period}`;
});



Vue.filter('dollar', function (value) {
    return new Intl.NumberFormat('en-us', {style: 'currency', currency: 'USD'}).format(value)
})

Vue.filter('percent', function (value) {
    return (value * 1).toFixed(2) + "%";
})


let optionsVueAWN = {
    position: "top-right",
    clean: true,
    labels: {
        tip: '',
        info: '',
        success: '',
        warning: '',
        alert: '',
        async: 'Loading',
        confirm: 'Confirmation required',
    },
    icons: {
        enabled: false,
    }
    //durations: {success: 0}
};
Vue.use(VueAWN, optionsVueAWN);

export const appVue = new Vue({
    el: '#app',
    mixins: [IframeMixin],
    data: {
        signatureWidth: 800,
        isMobile: false,

    },
    store,
    mounted() {
        this.calculateIsMobile()
        this.calculateSignatureWidth();
        window.addEventListener('resize', this.calculateSignatureWidth);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.calculateSignatureWidth);
    },
    methods: {
        calculateIsMobile() {
            const screenWidth = window.innerWidth;

            if (screenWidth > 768) {
                this.signatureWidth = 800;
                this.isMobile = false;
            } else if (screenWidth > 480) {
                this.signatureWidth = Math.min(screenWidth * 0.7, 480);
                this.isMobile = true;
            } else {
                this.signatureWidth = Math.min(screenWidth * 0.8, 320);
                this.isMobile = true;
            }
        },
        addTypeButton() {
            let th = document.getElementsByClassName('vgt-left-align sortable')
            for (let i = 0; i < th.length; i++) {
                let childs = th[i].children
                if (childs.length > 1) {
                    childs[1].setAttribute('type', 'button')
                }

            }
        },
        muuid() {
            let dt = new Date().getTime();
            const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                const r = (dt + Math.random() * 16) % 16 | 0;
                dt = Math.floor(dt / 16);
                return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
            });
            return uuid;
        },
        calculateSignatureWidth() {
            const screenWidth = window.innerWidth;

            if (screenWidth > 768) {
                this.signatureWidth = 800;
            } else if (screenWidth > 480) {
                this.signatureWidth = Math.min(screenWidth * 0.8, 600);
            } else {
                this.signatureWidth = Math.min(screenWidth * 0.9, 400);
            }
        }
    },
    components: {

        //Utils
        LinkDestroyComponent: () => import('./components/LinkDestroyComponent' /* webpackChunkName: "link-destroy-component" */),
        Auth: () => import('./components/Auth' /* webpackChunkName: "auth" */),
        DrawerLink: () => import('./components/generics/DrawerLink' /* webpackChunkName: "drawer-link" */),
        Feedback: () => import('./components/alerts/Feedback' /* webpackChunkName: "feedback" */),
        MImageUpload: () => import('./components/generics/MImageUpload' /* webpackChunkName: "m-image-upload" */),
        MImageAdd: () => import('./components/generics/MImageAdd' /* webpackChunkName: "m-image-add" */),
        IrGallery: () => import('./components/generics/IrGallery' /* webpackChunkName: "ir-gallery" */),
        IrGalleryDelete: () => import('./components/generics/IrGalleryDelete' /* webpackChunkName: "ir-gallery-delete" */),
        MVideoAdd: () => import('./components/generics/MVideoAdd' /* webpackChunkName: "m-video-add" */),
        MSignature: () => import('./components/generics/MSignature' /* webpackChunkName: "m-signature" */),
        TimeInputComponent: () => import('./components/generics/TimeInputComponent' /* webpackChunkName: "time-input-component" */),
        ProjectManagement: () => import('./components/generics/ProjectManagement' /* webpackChunkName: "project-management-component" */),
        FloatMaskComponent: () => import('./components/FloatMaskComponent' /* webpackChunkName: "float-mask-component" */),
        MGrid: () => import('./components/generics/m-grid/MGrid' /* webpackChunkName: "m-grid" */),
        TheMaskComponent: () => import('./components/TheMaskComponent' /* webpackChunkName: "the-mask-component" */),
        //SelectBooleanComponent: () => import('./components/SelectBooleanComponent' /* webpackChunkName: "select-boolean-component" */),
        //SelectComponent: () => import('./components/SelectComponent' /* webpackChunkName: "select-component" */),
        CheckboxComponent: () => import('./components/CheckboxComponent' /* webpackChunkName: "checkbox-component" */),
        MultipleSelectComponent: () => import('./components/MultipleSelectComponent' /* webpackChunkName: "multiple-select-component" */),
        MultipleSelectRams1Component: () => import('./components/MultipleSelectRams1Component' /* webpackChunkName: "multiple-select-rams1-component" */),
        SummernoteComponent: () => import('./components/SummernoteComponent' /* webpackChunkName: "summernote-component" */),
        //CKeditorComponent: () => import('./components/CKeditorComponent' /* webpackChunkName: "ckeditor-component" */),
        SelectBooleanNullableComponent: () => import('./components/SelectBooleanNullableComponent' /* webpackChunkName: "select-boolean-nullable-component" */),
        SearchBoxComponent: () => import('./components/generics/SearchBoxComponent' /* webpackChunkName: "search-box-component" */),
        SearchBoxMobileComponent: () => import('./components/generics/SearchBoxMobileComponent' /* webpackChunkName: "search-box-mobile-component" */),
        CustomSearchBoxComponent: () => import('./components/generics/CustomSearchBoxComponent' /* webpackChunkName: "custom-search-box-component" */),

        //Modules

        /**
         * Customers
         */
        CustomerPoServiceTicket: () => import('./components/modules/customers/CustomerPoServiceTicket' /* webpackChunkName: "customer-po-service-ticket" */),

        /**
         * Engineering Timesheet
         */
        EngineeringTimesheet: () => import('./components/modules/engineering_timesheet/EngineeringTimesheet' /* webpackChunkName: "engineering-timesheet" */),


        /**
         * Inspection reports
         */
        InspectionReportComments: () => import('./components/modules/sites/InspectionReportComments' /* webpackChunkName: "inspection-report-comments" */),


        /**
         * Inventories
         */
        InventoryFormComponent: () => import('./components/modules/inventories/InventoryFormComponent' /* webpackChunkName: "inventory-form-component" */),
        InventoryCsvComponent: () => import('./components/modules/inventories/InventoryCsvComponent' /* webpackChunkName: "inventory-csv-component" */),


        /**
         * Roles
         */

        RoleFormComponent: () => import('./components/modules/roles/RoleFormComponent' /* webpackChunkName: "role-form-component" */),
        ResendEmailComponent: () => import('./components/modules/sites/ResendEmailSchedule.vue' /* webpackChunkName: "resent-email-component" */),


        /**
         * Schedules
         */
        ScheduleInspectionFrequencyComponent: () => import('./components/modules/schedules/ScheduleInspectionFrequencyComponent' /* webpackChunkName: "schedule-inspection-frequency-component" */),
        ScheduleDescriptionComponent: () => import('./components/modules/schedules/ScheduleDescriptionComponent' /* webpackChunkName: "schedule-descriptions-component" */),
        ScheduleDatesComponent: () => import('./components/modules/schedules/ScheduleDatesComponent' /* webpackChunkName: "schedule-dates-component" */),
        ScheduleDatesSimpleComponent: () => import('./components/modules/schedules/ScheduleDateSimpleComponent.vue' /* webpackChunkName: "schedule-dates-simple-component" */),
        ScheduleStaffComponent: () => import('./components/modules/schedules/ScheduleStaffComponent' /* webpackChunkName: "schedule-staff-component" */),
        ScheduleServiceTicket: () => import('./components/modules/schedules/ScheduleServiceTicket' /* webpackChunkName: "schedule-service-ticket" */),
        CustomerPurchaseOrderSelect: () => import('./components/modules/sites/CustomerPurchaseOrderSelect' /* webpackChunkName: "customer-purchase-order-select" */),
        TechnicianTimesComponent: () => import('./components/modules/schedules/TechnicianTimesComponent' /* webpackChunkName: "technician-times-material-component" */),
        ScheduleInsuranceCertificate: () => import('./components/modules/schedules/ScheduleInsuranceCertificate.vue' /* webpackChunkName: "schedule-insurance-certificate" */),
        MySchedule: () => import('./components/modules/schedules/MySchedule.vue' /* webpackChunkName: "my-schedule" */),

        /**
         * Work Orders
         */
        MaterialsComponent: () => import('./components/modules/work_orders/MaterialsComponent' /* webpackChunkName: "work-orders-material-component" */),
        ProposalMaterialsComponent: () => import('./components/modules/work_orders/ProposalMaterialsComponent' /* webpackChunkName: "work-orders-proposal-material-component" */),
        DocumentsComponent: () => import('./components/modules/work_orders/DocumentsComponent' /* webpackChunkName: "work-orders-documents-component" */),
        WorkOrderTimerComponent: () => import('./components/modules/work_orders/WorkOrderTimerComponent' /* webpackChunkName: "work-orders-timer-component" */),
        Timer: () => import('./components/modules/work_orders/Timer' /* webpackChunkName: "timer-component" */),
        ModalInvoiceComponent: () => import('./components/modules/work_orders/ModalInvoiceComponent' /* webpackChunkName: "modal-invoice-component" */),
        TeamMembersComponent: () => import('./components/modules/teams/TeamMembersComponent' /* webpackChunkName: "teams-members-component" */),
        ExecutiveTimesheetReport: () => import('./components/modules/work_orders/ExecutiveTimesheetReport' /* webpackChunkName: "executive-timesheet-report" */),


        /**
         * Contracts
         */
        ContractInstallmentsComponent: () => import('./components/modules/contracts/ContractInstallmentsComponent' /* webpackChunkName: "contract-installments-component" */),
        ContractInstallmentComponent: () => import('./components/modules/contracts/ContractInstallmentComponent' /* webpackChunkName: "contract-installment-component" */),
        ContractDocumentsComponent: () => import('./components/modules/contracts/ContractDocumentsComponent' /* webpackChunkName: "contract-documents-component" */),
        ContractServiceTaxesComponent: () => import('./components/modules/contracts/ContractServiceTaxes.vue' /* webpackChunkName: "contract-service-taxes-component" */),

        /**
         * Prices
         */
        PriceItemsComponent: () => import('./components/modules/work_orders/PriceItemsComponent' /* webpackChunkName: "price-items-component" */),


        /**
         * Sites
         */

        /*   InspectionFrequencyComponent: () => import('./components/modules/sites/InspectionFrequencyComponent' /!* webpackChunkName: "site-inspection-frequency-component" *!/),
           SiteCardComponent: () => import('./components/modules/sites/SiteCardComponent' /!* webpackChunkName: "site-card-component" *!/),
           SiteHeaderSummaryComponent: () => import('./components/modules/sites/SiteHeaderSummaryComponent' /!* webpackChunkName: "site-header-summary-component" *!/),
           SiteHeaderComponent: () => import('./components/modules/sites/SiteHeaderComponent' /!* webpackChunkName: "site-header-component" *!/),
           SiteDocumentsComponent: () => import('./components/modules/sites/SiteDocumentsComponent' /!* webpackChunkName: "site-documents-component" *!/),
           ClientContactsSite: () => import('./components/modules/sites/ClientContactsSite' /!* webpackChunkName: "site-client-contacts" *!/),
           GenericSites: () => import('./components/modules/sites/GenericSites' /!* webpackChunkName: "generic-sites" *!/),*/
        //ShortcutLinkItemComponent: () => import('./components/modules/shortcut_links/ShortcutLinkItemComponent' /* webpackChunkName: "shortcut-links-items" */),
        PropagationChange: () => import('./components/modules/sites/PropagationChange' /* webpackChunkName: "propagation-change" */),
        PurchaseRequestItemComponent: () => import('./components/modules/purchase_requests/PurchaseRequestItemComponent' /* webpackChunkName: "purchase-request-items" */),

    },
});


